import Cookies from 'js-cookie';

const GetCookie = (key) => Cookies.get(key);

export default GetCookie;
